import OurSolutions from './OurSolutions';

export default OurSolutions;
